<template>
    <form @submit.prevent="personContactInfo_Submit">
        <div class="card">
            <div class="card-header">
                个人联系信息管理
            </div>
            <div class="card-body">
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right" for="inputEmailAddress">电子邮箱<span class="text-danger">*</span></label>
                    <div class="col-sm-4">
                        <input type="email" class="form-control" id="inputEmailAddress" v-model="personContactInfo.emailAddress" :required="requiredEmailAddress">
                    </div>
                    <label class="col-sm-2 col-form-label text-right" for="inputMobilePhone">移动电话<span class="text-danger">*</span></label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputMobilePhone" v-model="personContactInfo.mobilePhone" pattern="[0-9]{11}" :required="requiredMobilePhone">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right" for="inputPhoneNumber">固定电话</label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputPhoneNumber" v-model="personContactInfo.phoneNumber">
                    </div>
                    <label class="col-sm-2 col-form-label text-right" for="inputWeixin">微信号码</label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputWeixin" v-model="personContactInfo.weixin">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right" for="inputQQ">QQ号码</label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputQQ" v-model="personContactInfo.qq">
                    </div>
                    <label class="col-sm-2 col-form-label text-right" for="inputDingding">钉钉号码</label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputDingding" v-model="personContactInfo.dingding">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right" for="inputFax">传真号码</label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputFax" v-model="personContactInfo.fax">
                    </div>
                    <label class="col-sm-2 col-form-label text-right" for="inputPostCode">邮政编码</label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputPostCode" v-model="personContactInfo.postCode">
                    </div>

                </div>
                <div class="form-group row mb-0">
                    <label class="col-sm-2 col-form-label text-right" for="inputAddress">联系地址</label>
                    <div class="col-sm-2">
                        <select class="form-control" id="inputProvinceId" v-model="personContactInfo.provinceId" @input="personContactInfo.cityId=null">
                            <option v-for="pro in provinceData" :key="pro.provinceId" :value="pro.provinceId">{{pro.provinceName}}</option>
                        </select>
                    </div>
                    <div class="col-sm-2">
                        <select class="form-control" id="inputCityId" v-model="personContactInfo.cityId">
                            <option :value="null">（请选择）</option>
                            <option v-for="city in cityData" :key="city.cityId" :value="city.cityId">{{city.cityName}}</option>
                        </select>
                    </div>
                    <div class="col-sm-6">
                        <input type="text" class="form-control" id="inputAddress" v-model="personContactInfo.contactAddress">
                    </div>
                </div>
            </div>
            <div class="card-footer text-center">
                <button class="btn btn-primary" type="submit">保存</button>
            </div>
        </div>
    </form>
</template>

<script>
import baseApi from "@/utils/api/base";
import userApi from "@/utils/api/user";
import dictionary from "@/utils/dictionary";
export default {
    name: "OrganPersonContactInfoEdit",
    props: {
        personId: {type: String, required: true},
        requiredMobilePhone: {type: Boolean, required: false, default: false},
        requiredEmailAddress: {type: Boolean, required: false, default: false},
    },
    data: function () {
        return {
            provinceData: [],
            cityData: [],

            personContactInfo: {},
            queryInfo: {
                personId: '',
                userType: localStorage.getItem("userType"),
            }
        };
    },
    mounted() {
        this.getProvinceData();
        this.getPersonContactInfo();
    },
    methods: {
        getProvinceData() {
            baseApi.region.getProvinceData().then(res => {
                this.provinceData = res.data;
            });
        },
        getCityData() {
            baseApi.region.getCityData(this.personContactInfo.provinceId).then(res => {
                this.cityData = res.data;
            });
        },

        getPersonContactInfo() {
            userApi.person.contact.getOrganContactInfo(this.personId).then(res => {
               this.personContactInfo = res.data;
               if (!this.personContactInfo || !this.personContactInfo.provinceId) {
                   this.personContactInfo.provinceId = '210000';
               }

               this.getCityData();
            });
        },

        personContactInfo_Submit() {
            userApi.person.contact.updateOrganContactInfo(this.personContactInfo).then(res => {
                this.personContactInfo = res.data;
                if (!this.personContactInfo.provinceId) {
                    this.personContactInfo.provinceId = '210000';
                }
                alert('联系信息已保存！');
            })
            
        }
    }
}
</script>

<style scoped>

</style>